import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';

import { LimitedList } from 'js/components';

import { useStandardCollator } from 'js/utils/string';

import styles from './ProductManagersDashboard.module.scss';

const MAX_LIST_ITEMS = 5;

const ProductManager = ({ productManager }) => {
  const { workspaceId } = useParams();
  const collator = useStandardCollator();

  const userGroups = useMemo(
    () => productManager?.stats?.user_groups ?? [],
    [productManager?.stats?.user_groups]
  );

  const capabilities = useMemo(() => {
    const capabilities = new Map();
    userGroups.forEach((userGroup) => {
      userGroup.capability_sets.forEach((capabilitySet) => {
        capabilitySet.capabilities.forEach((capability) => {
          capabilities.set(capability.id, capability);
        });
      });
    });

    return Array.from(capabilities.values()).sort(
      (a, b) => collator.compare(a.name, b.name) || collator.compare(a.id, b.id)
    );
  }, [userGroups, collator]);

  return (
    <>
      <div className={styles['product-manager']}>
        <div className={styles['product-manager-name']}>
          <Link
            to={`/w/${workspaceId}/pm/product-managers/${productManager.id}`}
          >
            {productManager.name}
          </Link>
        </div>
        <div className={styles['product-manager-user-groups']}>
          <LimitedList
            items={userGroups}
            maxItems={MAX_LIST_ITEMS}
            itemKey={(ug) => ug.id}
            renderItem={(ug) => ug.name}
          />
        </div>
        <div className={styles['product-manager-capabilities']}>
          <LimitedList
            items={capabilities}
            maxItems={MAX_LIST_ITEMS}
            itemKey={(capability) => capability.id}
            renderItem={(capability) => capability.name}
          />
        </div>
        <div className={styles['product-manager-actions']}></div>
      </div>
      <div className={styles['divider']} />
    </>
  );
};

export default ProductManager;
